import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { WithStyles } from "@material-ui/core";
import { styles } from "./DetailPanel.styles";
import { IUniversalTableColumn, IUniversalTableData, IUniversalTableDetailPanelColumn } from "./interfaces";
import UniversalTable from "./UniversalTable";

export interface IDetailPanelProps extends WithStyles<typeof styles> {
    columns: IUniversalTableDetailPanelColumn[];
    data: IUniversalTableData;
}

const DetailPanelPure: React.FunctionComponent<IDetailPanelProps> = ({ classes, columns, data }: IDetailPanelProps) => {
    const tableColumns: IUniversalTableColumn[] = columns.map((column) => ({
        ...column,
        type: column?.type || "text",
    }));
    return (
        <div className={classes.root}>
            <UniversalTable pagingDisabled columns={tableColumns} data={data} dense />
        </div>
    );
};

export const DetailPanel = withStyles(styles)(DetailPanelPure);
